import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ActionStatus, useWarehouseAddressCollectionData } from '@steelbuy/data-provider';
import { AddressModel, Mutable } from '@steelbuy/ts-shared';
import { AddressForm } from '@steelbuy/ui-domain';
import { RoutePath } from '../../router/Routes';
import { FormLayout } from '../../views/layouts/form-layout/FormLayout';
import { CreateListingUnsavedChangesModal } from '../create-listing-unsaved-changes-modal/CreateListingUnsavedChangesModal';
import { PageHeader } from '../page-header/PageHeader';

export const CreateListingAddPickupAddress = () => {
    const { t } = useTranslation('translation');
    const navigate = useNavigate();
    const warehouseAddressCollectionData = useWarehouseAddressCollectionData();

    const [error, setError] = useState<string>();

    warehouseAddressCollectionData.useActionStatusEffect(
        [ActionStatus.FAILED],
        () => {
            setError(t('application.createListingAddPickupAddress.errorMessage'));
        },
        true
    );

    warehouseAddressCollectionData.useActionStatusEffect(
        [ActionStatus.CREATE_SUCCESS],
        () => {
            // Refresh all addresses, because the primary address could have changed.
            warehouseAddressCollectionData.resolveFetchStatus();
            navigate(RoutePath.CREATE_LISTING_CHOOSE_PICKUP_ADDRESS);
        },
        false
    );

    const handleSave = (address: Mutable<AddressModel>) => {
        warehouseAddressCollectionData.create(address);
    };

    return (
        <>
            <PageHeader
                pageTitle={t('application.createListingAddPickupAddress.pageTitle')}
                previousPageTitle={t('application.createListingAddPickupAddress.previousPageTitle')}
                onBackClick={() => navigate(RoutePath.CREATE_LISTING_CHOOSE_PICKUP_ADDRESS)}
            />
            <FormLayout>
                <AddressForm
                    error={error}
                    onCancel={() => navigate(RoutePath.CREATE_LISTING_CHOOSE_PICKUP_ADDRESS)}
                    onPrimary={handleSave}
                />
            </FormLayout>
            <CreateListingUnsavedChangesModal />
        </>
    );
};
